import constantes from '../helpers/constanteHelper'

import { useNavigate } from 'react-router-dom'

import Image from "react-bootstrap/Image";

import produtoDefault from '../images/produto-default.png'

function CardProdutoRedutor({ produto, exibirMenu = true, resolucaoMobile, key, desativarLink, idioma, slugEmpresa }) {
    const navigate = useNavigate()

    const urlProduto = exibirMenu ? `/catalogo-rpc/produtos/${produto['Slug (Url)']}` : `/catalogo-rpc/produtos/${produto['Slug (Url)']}?menu=false`

    function definirNomeProduto(produto) {
        let nomeInicial = produto['Nome do produto/serviço']

        if (idioma === 'es') {
            if (produto['Nome do produto/serviço (Espanhol)']) {
                nomeInicial = produto['Nome do produto/serviço (Espanhol)']
            }
        } else if (idioma === 'en') {
            if (produto['Nome do produto/serviço (Inglês)']) {
                nomeInicial = produto['Nome do produto/serviço (Inglês)']
            }
        }  else if (idioma === 'fr') {
            if (produto['Nome do produto/serviço (Francês)']) {
                nomeInicial = produto['Nome do produto/serviço (Francês)']
            }
        }

        return nomeInicial
    }


    function retornarLinkImagemProduto(idioma) {
        if (idioma === 'en') {
            return produto['Link da imagem do produto (Inglês)'] ? produto['Link da imagem do produto (Inglês)'] : produto['Link da imagem do produto'] ? produto['Link da imagem do produto'] : undefined
        } else if (idioma === 'es') {
            return produto['Link da imagem do produto (Espanhol)'] ? produto['Link da imagem do produto (Espanhol)'] : produto['Link da imagem do produto'] ? produto['Link da imagem do produto'] : undefined
        } else if (idioma === 'fr') {
            return produto['Link da imagem do produto (Francês)'] ? produto['Link da imagem do produto (Francês)'] : produto['Link da imagem do produto'] ? produto['Link da imagem do produto'] : undefined
        } else {
            return produto['Link da imagem do produto'] ? produto['Link da imagem do produto'] : undefined
        }
    }

    return (
        <div key={key ? key : ''} className='animate__animated animate__fadeIn flex-column d-flex align-items-center justify-content-start' onClick={desativarLink ? () => { } : () => { navigate(urlProduto, { state: { idioma, slugEmpresa } }) }} style={{ marginBottom: resolucaoMobile ? '20px' : '0px', cursor: 'pointer', width: resolucaoMobile ? '110px' : '173px', height: resolucaoMobile ? '170px' : '270px', borderRadius: '20px' }}>
            <div className='animate__animated animate__fadeIn d-flex align-items-center justify-content-center' style={{ cursor: 'pointer', width: resolucaoMobile ? '110px' : '173px', height: resolucaoMobile ? '120px' : '180px', background: constantes.CORES.BRANCO_PADRAO, borderRadius: '20px' }}>
                <Image style={{ height: resolucaoMobile ? '150px' : '180px', objectFit: 'contain', padding: '20px' }} src={retornarLinkImagemProduto(idioma) ?? produtoDefault} alt="logo" fluid />
            </div>
            <span className='mt-3' style={{ fontSize: resolucaoMobile ? '14px' : '18px', textAlign: 'center', color: constantes.CORES.BRANCO_PADRAO }}>{definirNomeProduto(produto)}</span>

        </div>
    );
}
export default CardProdutoRedutor;
